<template>
  <b-navbar
    type="light"
    toggleable="xl"
    v-b-scrollspy:nav-scroller
    class="header-area header-agency"
    :class="{ 'is-sticky': scrolled }"
  >
    <div class="container-fluid container-fluid--cp-150">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-navbar-brand class="navbar-brand" to="/"
        ><img src="@/assets/img/logo/Logo-forum.svg" alt="logo"
      /></b-navbar-brand>
      <b-collapse
        class="default-nav justify-content-end"
        is-nav
        id="nav_collapse"
      >
        <b-navbar-nav class="navbar-nav main-menu">
         <b-nav-item class="menu-iniciar-sesion" href="https://forumapp.progrentis.com"
            ><span>Iniciar sesión</span></b-nav-item
          >
          <b-nav-item href="https://forumapp.progrentis.com/cartelera-cursos/"
            ><span>Cursos</span></b-nav-item
          >
        </b-navbar-nav>
      </b-collapse>
      <b-btn-group class="header-button button--white d-none d-xl-block mr-3">
        <b-link href="https://forumapp.progrentis.com/" class="ht-btn boton-iniciar-sesion ht-btn--outline d-xl-block"
          >Iniciar sesión</b-link
        >
      </b-btn-group>
      <b-btn-group class="header-button button--white d-none d-xl-block">
        <b-link href="https://forumapp.progrentis.com/registro" class="boton-registrate ht-btn d-xl-block">Registrarse</b-link>
      </b-btn-group>
    </div>
  </b-navbar>
</template>

<script>
export default {
  name: "headerForum",
  data() {
    return {
      load: false,
      limitPosition: 200,
      scrolled: false,
      lastPosition: 500,
    };
  },
  mounted() {
    (function () {
      scrollTo();
    })();

    function scrollTo() {
      const links = document.querySelectorAll(".scroll > a");
      links.forEach((each) => (each.onclick = scrollAnchors));
    }

    function scrollAnchors(e, respond = null) {
      const distanceToTop = (el) => Math.floor(el.getBoundingClientRect().top);
      e.preventDefault();
      var targetID = respond
        ? respond.getAttribute("href")
        : this.getAttribute("href");
      const targetAnchor = document.querySelector(targetID);
      if (!targetAnchor) return;
      const originalTop = distanceToTop(targetAnchor);
      window.scrollBy({ top: originalTop, left: 0, behavior: "smooth" });
      const checkIfDone = setInterval(function () {
        const atBottom =
          window.innerHeight + window.pageYOffset >=
          document.body.offsetHeight - 190;
        if (distanceToTop(targetAnchor) === 0 || atBottom) {
          targetAnchor.tabIndex = "-1";
          targetAnchor.focus();
          clearInterval(checkIfDone);
        }
      }, 800);
    }
  },
  methods: {
    // sticky menu script
    handleScroll() {
      if (
        this.lastPosition < window.scrollY &&
        this.limitPosition < window.scrollY
      ) {
        this.scrolled = true;
        // move up!
      }
      if (this.lastPosition > window.scrollY) {
        this.scrolled = true;
        // move down
      }
      this.lastPosition = window.scrollY;
      this.scrolled = window.scrollY > 50;
    },

    // offcanvas searchbox
    toggleClass(addRemoveClass, className) {
      const el = document.querySelector("#search-overlay");
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
.header-agency {
  &.is-sticky {
    top: 0;
    left: 0;
    position: fixed;
    width: 100%;
  }
}
.boton-registrate {
  font-size: 15px;
  font-weight: 500;
  border-style: solid;
  border-radius: 43px;
  border-color: transparent;
  padding: 10px 36px;
  text-align: center;
  color: #fff;
  background: linear-gradient(45deg, #ff5601 0%, #ff8001 100%);
  background-size: 200% auto;
  background-position: left center;
  border-width: 1px;
  transform: translateY(0px);
  &:hover,
  &:active,
  &:focus {
    color: #fff;
    background: linear-gradient(45deg, #ff5601 0%, #ff8001 100%);
    background-position: right center;
    transform: translateY(-3px);
  }
}
.boton-iniciar-sesion {
    font-size: 15px;
    font-weight: 500;
    border-style: solid;
    border-radius: 43px;
    border-color: #FF5601;
    color: #000;
    line-height: inherit;
    padding: 10px 36px;
    text-align: center;
    background-size: 200% auto;
    background-position: left center;
    border-width: 1px;
    transform: translateY(0px);
    &:hover,
    &:active,
    &:focus {
      color: #fff;
      background: linear-gradient(45deg, #ff5601 0%, #ff8001 100%);
      background-position: right center;
      transform: translateY(-3px);
    }
  }
  .menu-iniciar-sesion{
    display: block;
    @media (min-width: 992px){
      display: none;  
    }
  }
</style>